// extracted by mini-css-extract-plugin
export default {"signInPage":"SignInPage_signInPage__f7uX8","signInBlock":"SignInPage_signInBlock__aFl5F"};